import MapServiceModel        from '@/models/MapServiceModel';
import doc                     from '@widesk-core/decorators/doc';
import { DxfLayer }            from '@models/map/dxfTypes';
import { DxfSuggestedCategory } from '@models/map/dxfTypes';
import { PlanDecorLayer }       from '@models/map/dxfTypes';

/**
 * Opération custom `POST /imports/{id}/plan/layers` : liste les calques visibles du
 * DXF attaché et propose un mapping initial regroupé par famille (best-effort,
 * ajustable côté front). Lecture seule.
 * Appel : `setId(importId).save({ method: 'post' })`.
 */
@doc.path('/imports/{id}/plan/layers')
export default class DxfLayersModel extends MapServiceModel {
	@doc.json declare layers: DxfLayer[];
	@doc.json declare suggestedMapping: DxfSuggestedCategory[];
	@doc.json declare suggestedDecor: PlanDecorLayer[];
}
